import { useEffect } from 'react'
import { getListCategoriaObligacion, getListObligacion, getListRolesByCategory, getObligationSubLegalEntities } from '../../../services/sCO/obligation.service';
import { isNullUndefinedOrEmptyOrZero } from '../../../common/Helpers';
import { getHomeContractObligationAchieves, getListObligationConrtacts, getObligationAchieveElement, getObligationElement, getObligationElementList } from '../../../services/sCO/obligationElement.service';
import { getNotificationDetails } from '../../../services/sNotificationAlerts/notificationAlerts.service';


const useGetObligationCategorysMaintainer = (obligationCategory, setObligationCategory) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                const serviceResponse = await getListCategoriaObligacion();
                const response = serviceResponse.data;

                if (response.succeeded) {
                    setObligationCategory && setObligationCategory(response.data);
                }
                else {
                    setObligationCategory && setObligationCategory([])
                }
            }
            catch (error) {
                setObligationCategory && setObligationCategory([])

            }
        }
        
        if (obligationCategory === null) {
            getData()
        }
    }, [obligationCategory, setObligationCategory]);
}

const useGetObligationsMaintainer = (obligations, setObligations) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                const serviceResponse = await getListObligacion();
                const response = serviceResponse.data;

                if (response.succeeded) {
                    setObligations && setObligations(response.data);
                }
                else {
                    setObligations && setObligations([]);
                }
            }
            catch (error) {
                setObligations && setObligations([]);
            }
        }
        
        if (obligations === null) {
            getData()
        }
    }, [obligations, setObligations]);
}

const useGetListObligationContracts = (obligationId, obligationContractList, setObligationContractList, seObligationContractFiltred, isPanelOpen, forceGetContracts, setForceGetContracts) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getListObligationConrtacts(obligationId);
                const response = serviceResponse.data;

                if (response.succeeded) {
                    if (response.data !== null) {
                        setObligationContractList && setObligationContractList(prevState => ({
                            ...prevState,
                            data: response.data,
                            fireUpdate:true
                        }))

                        seObligationContractFiltred && seObligationContractFiltred(prevState => ({
                            ...prevState,
                            data: response.data,
                            fireUpdate:true
                        }))
                    }
                    else {
                        setObligationContractList && setObligationContractList(prevState => ({
                            ...prevState,
                            data: [],
                            fireUpdate:true
                        }))

                        seObligationContractFiltred && seObligationContractFiltred(prevState => ({
                            ...prevState,
                            data: [],
                            fireUpdate:true
                        }))
                    }
                }
                else {
                    setObligationContractList && setObligationContractList(prevState => ({
                        ...prevState,
                        data: [],
                        fireUpdate:true
                    }))

                    seObligationContractFiltred && seObligationContractFiltred(prevState => ({
                        ...prevState,
                        data: [],
                        fireUpdate:true
                    }))
                }
                
                setForceGetContracts(false)
            }
            catch (error) {
                setObligationContractList && setObligationContractList(prevState => ({
                    ...prevState,
                    data: [],
                    fireUpdate:true
                }))

                seObligationContractFiltred && seObligationContractFiltred(prevState => ({
                    ...prevState,
                    data: [],
                    fireUpdate:true
                }))

                setForceGetContracts(false)
            }
        }
        
        if (obligationId !== null && (obligationContractList.data === null || forceGetContracts) && isPanelOpen) {
            getData()
        }
    }, [obligationId, obligationContractList, setObligationContractList, isPanelOpen, forceGetContracts, setForceGetContracts]);
}

const useGetObligationListRolesByCategory = (categoryId, roleList, setRoleList) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                const serviceResponse = await getListRolesByCategory(categoryId);
                const response = serviceResponse.data;

                if (response.succeeded) {
                    setRoleList && setRoleList(response.data);
                }
                else {
                    setRoleList && setRoleList([]);
                }
            }
            catch (error) {
                setRoleList && setRoleList([]);
            }
        }
        
        if (!isNullUndefinedOrEmptyOrZero(categoryId) && roleList === null) {
            getData()
        }
    }, [categoryId, roleList, setRoleList]);
}

const useGetObligationSubLegalEntities = (obligationId, subLegalEntityList, setSubLegalEntityList) => {
    useEffect(()=> {
        const getData = async () => {
            try {
                const serviceResponse = await getObligationSubLegalEntities(obligationId);
                const response = serviceResponse.data;

                if (response.succeeded) {
                    setSubLegalEntityList && setSubLegalEntityList(response.data);
                }
                else {
                    setSubLegalEntityList && setSubLegalEntityList([]);
                }
            }
            catch (error) {
                setSubLegalEntityList && setSubLegalEntityList([]);
            }
        }

        if (!isNullUndefinedOrEmptyOrZero(obligationId) && subLegalEntityList === null) {
            getData()
        }
    }, [obligationId, subLegalEntityList, setSubLegalEntityList]);
}

const useGetHomeContractObligationAchieves = (homeCOList, homeCOListFiltred, setHomeCOList, setHomeCOListFiltred) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                const serviceResponse = await getHomeContractObligationAchieves();
                const response = serviceResponse.data;

                if (response.succeeded) {
                    setHomeCOList && setHomeCOList(response.data);
                    setHomeCOListFiltred && setHomeCOListFiltred(response.data);
                }
                else {
                    setHomeCOList && setHomeCOList([]);
                    setHomeCOListFiltred && setHomeCOListFiltred([]);
                }
            }
            catch (error) {
                setHomeCOList && setHomeCOList([]);
                setHomeCOListFiltred && setHomeCOListFiltred([]);
            }
        }
        
        if (homeCOList === null && homeCOListFiltred === null) {
            getData()
        }
    }, [homeCOList, homeCOListFiltred, setHomeCOList, setHomeCOListFiltred]);
}

const useGetObligationElementList = (elementId, obligations, setObligations, setObligation, obligationIdSelectedId) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                const serviceResponse = await getObligationElementList(elementId);
                const response = serviceResponse.data;

                if (response.succeeded) {
                    setObligations && setObligations(response.data);

                    if (response.data.length > 0) {
                        const serviceResponseObligationElement = await getObligationElement(elementId, !isNullUndefinedOrEmptyOrZero(obligationIdSelectedId) ? obligationIdSelectedId : response.data[0].id);

                        if (serviceResponseObligationElement.data.succeeded) {
                            setObligation && setObligation(serviceResponseObligationElement.data.data);
                        }
                        else {
                            setObligation && setObligation(null);
                        }  
                    }
                    else {
                        setObligation && setObligation(null);
                    }
                }
                else {
                    setObligations && setObligations([]);
                }
            }
            catch (error) {
                setObligations && setObligations([]);
            }
        }
        
        if (obligations === null) {
            getData()
        }
    }, [elementId, obligations, setObligations, obligationIdSelectedId]);
}

const useGetObligationAchieves = (elementId, obligationId, listObligationAchieves, setlistObligationAchieves) => {    
    useEffect(() => { 
        if (elementId === null || obligationId === null || listObligationAchieves !== null) {
            return;
        }

        let cancelled = false;

        const getData = async () => {
            try {
                const serviceResponse = await getObligationAchieveElement(elementId, obligationId);
                const response = serviceResponse.data;

                if (cancelled) {
                    return;
                }

                if (response.succeeded) {
                    setlistObligationAchieves && setlistObligationAchieves(response.data);
                }
                else {
                    setlistObligationAchieves && setlistObligationAchieves([]);
                }
            }
            catch (error) {
                if (!cancelled) {
                    setlistObligationAchieves && setlistObligationAchieves([]);
                }
            }
        };
        
        getData();

        return () => {
            cancelled = true;
        };
    }, [elementId, obligationId, listObligationAchieves, setlistObligationAchieves]);
}

const useGetObligationAchieveById = (notificationId, setObjNotification, forceGet, setForceGet) => {    
    useEffect(() => { 
        if (notificationId === null || forceGet !== true) {
            return;
        }

        let cancelled = false;

        const getData = async () => {
            setObjNotification && setObjNotification(null);

            try {
                const serviceResponse = await getNotificationDetails(notificationId);
                const response = serviceResponse.data;

                if (cancelled) {
                    return;
                }

                if (response.succeeded) {
                    setObjNotification && setObjNotification(response.data);
                }
                else {
                    setObjNotification && setObjNotification(null);
                }
            }
            catch (error) {
                if (!cancelled) {
                    setObjNotification && setObjNotification(null);
                }
            }
            finally {
                if (!cancelled) {
                    setForceGet && setForceGet(false);
                }
            }
        };
        
        getData();

        return () => {
            cancelled = true;
        };
    }, [notificationId, setObjNotification, forceGet, setForceGet]);
}



export {
    useGetObligationAchieveById,
    useGetObligationAchieves,
    useGetObligationsMaintainer,
    useGetObligationCategorysMaintainer,
    useGetListObligationContracts,
    useGetObligationListRolesByCategory,
    useGetHomeContractObligationAchieves,
    useGetObligationElementList,
    useGetObligationSubLegalEntities,
}